import ItemsPage from "./subpages/ItemsPage";

const page = (page_name) => {
  return <>{page_name === "items" && <ItemsPage />}</>;
};

export default page;
